import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {cartRegister} from "../../services/cartRegister"
import {imagesRegister} from "../../services/imagesRegister"
import {quotesRegister} from "../../services/quotesRegister"
import cx from "classnames";
import {marketRegister} from "../../services/marketRegister";

class ErrorHandler extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {}

    _restart(){
        if(this.props.props){
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() +"/signup/image");
            window.location.reload();
        }
    }

    _renderText(item) {
        return langRegister.get("error-handler", item);
    }

    render() {
        return (
              <div className={Styles.error}>
                  <div>
                      {this._renderText("item_1")}
                  </div>
                  {
                      this.props.props &&
                      <div className={Styles.button} onClick={() => this._restart()}>
                          {this._renderText("item_2")}
                      </div>
                  }
              </div>
        );
    }
}

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/components/error-handler/component.js